<template>
  <section class="wrap_pop">
        <div class="popbox_wrap">
            <div class="popbox_cont">
                <h1 class="pop_tit">개인(신용)정보의 수집·이용에 관한 동의</h1>
                <div class="cont_agree">
                    <ul class="list_type01">
                        <li>당사 및 당사 업무수탁자는 「개인정보보호법」 및 「신용정보의 이용 및 보호에 관한 법률」 에 따라 귀하의 개인(신용)정보를 다음과 같이 수집·이용하고자 합니다.</li>
                        <li>
                            <ul class="list_type02">
                                <li>· 개인(신용)정보의 수집·이용목적 : 본인 확인</li> 
                                <li>· 수집·이용할 개인(신용)정보의 내용 : 성명, 생년월일, 연락처</li>
                                <li>· 제공받는 자의 개인(신용)정보 보유</li>
                                <li>  - 보유 이용 기간 : 수집·이용 동의일로부터 5년</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="popbox_btn">
                <!-- <div><button type="button" class="btn color2">취소</button></div> -->
                <div><button type="button" class="btn color1" @click="$emit('close')">확인</button></div>
            </div>
        </div>
    </section>
</template>